export default __webpack_public_path__ + "static/media/Rubik-ExtraBold.b30aba6d.ttf";